/*
 * CUSTOM: Cart toast.
 * Shows a small non-blocking toast at the top of the screen after a product is
 * added to the cart, with a "View cart" button that opens the theme's cart
 * drawer. Pairs with Theme setting "After adding to cart = Do nothing" so the
 * drawer no longer takes over the screen on every add.
 *
 * Isolated file — remove the 2 include lines in layout/theme.liquid to disable.
 */
(function () {
  var HIDE_DELAY = 5000;
  var toast;
  var timer;

  function build() {
    toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<button type="button" class="cart-toast__close" aria-label="Mbyll">&times;</button>' +
      '<span class="cart-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 16 16" width="20" height="20"><path fill="currentColor" d="M6.2 11.3 2.9 8l1.1-1.1 2.2 2.2 5-5L12.3 5z"/></svg>' +
      '</span>' +
      '<p class="cart-toast__msg">Produkti u shtua në shportë</p>' +
      '<button type="button" class="cart-toast__view">Shiko shportën</button>' +
      '<button type="button" class="cart-toast__continue">Vazhdo shopping</button>';
    document.body.appendChild(toast);

    toast.querySelector('.cart-toast__view').addEventListener('click', function () {
      hide();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    });
    toast.querySelector('.cart-toast__continue').addEventListener('click', hide);
    toast.querySelector('.cart-toast__close').addEventListener('click', hide);
  }

  function show() {
    if (!toast) build();
    toast.classList.add('is-visible');
    clearTimeout(timer);
    timer = setTimeout(hide, HIDE_DELAY);
  }

  function hide() {
    if (toast) toast.classList.remove('is-visible');
    clearTimeout(timer);
  }

  // Only react to real add-to-cart actions (from a product form), not cart-page
  // quantity edits which also emit on:line-item:change.
  function fromProductForm(evt) {
    return evt.target && evt.target.closest && evt.target.closest('product-form');
  }

  document.addEventListener('on:cart:add', show);
  document.addEventListener('on:line-item:change', function (evt) {
    if (fromProductForm(evt)) show();
  });
})();
